import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";
const AUTO_DISMISS_MS = 12000;

export default function FeedbackToast({ onClose, t = (k) => k }) {
  const [stars, setStars] = useState(0);
  const [hovered, setHovered] = useState(0);
  const [comment, setComment] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [interacted, setInteracted] = useState(false);

  useEffect(() => {
    if (interacted) return;
    const timer = setTimeout(() => onClose(), AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [interacted, onClose]);

  const handleStarClick = (s) => {
    setStars(s);
    setInteracted(true);
  };

  const handleCommentChange = (e) => {
    setComment(e.target.value);
    setInteracted(true);
  };

  const handleSubmit = async () => {
    if (!stars) return;
    setLoading(true);
    try {
      await axios.post(`${API}/feedback`, { stars, comment: comment.trim() || null });
    } catch {
      // On remercie quand même
    }
    localStorage.setItem("rms_feedback_given", "1");
    setSent(true);
    setLoading(false);
    setTimeout(() => onClose(), 2500);
  };

  const handleClose = () => {
    localStorage.setItem("rms_feedback_given", "1");
    onClose();
  };

  return (
    <div className="feedback-toast">
      <button className="feedback-toast-close" onClick={handleClose} aria-label={t("feedback_close")} style={{ display: "flex" }}>
        <X size={14} />
      </button>
      {sent ? (
        <p className="feedback-thanks">{t("feedback_thanks")}</p>
      ) : (
        <>
          <p className="feedback-question">{t("feedback_question")}</p>
          <div className="feedback-stars">
            {[1, 2, 3, 4, 5].map((s) => (
              <span
                key={s}
                className={`feedback-star${s <= (hovered || stars) ? " active" : ""}`}
                onMouseEnter={() => setHovered(s)}
                onMouseLeave={() => setHovered(0)}
                onClick={() => handleStarClick(s)}
              >
                ★
              </span>
            ))}
          </div>
          <textarea
            className="feedback-comment"
            placeholder={t("feedback_placeholder")}
            value={comment}
            onChange={handleCommentChange}
            rows={2}
            maxLength={300}
          />
          <button
            className="feedback-submit"
            onClick={handleSubmit}
            disabled={!stars || loading}
          >
            {loading ? "..." : t("feedback_submit")}
          </button>
        </>
      )}
    </div>
  );
}
